@if (loading) {
  <loading class="pos-abs vh-center"></loading>
}
<div class="tw-fixed tw-left-6 tw-top-6 tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" (click)="back()">
  <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'arrow_back'"></cs-icon>
</div>
@if (!loading) {
  <div class="hbox rebranding-hbox font-noto">
    <div class="flex-box">
      <div class="flex-content pos-rel" [class.tw-bg-blue-200]="!isReportV2" [class.bg-grad]="!isReportV2" [class.tw-bg-teal-200]="isReportV2" #scrollContainer="">
        <div class="tw-pt-24 tw-px-4 tw-mb-4" [class.tw-bg-grid-layout]="!isReportV2">
          @if ([appConfig.Shared.Regimen.Class.FACE, appConfig.Shared.Regimen.Class.BODY].includes(report?.type)) {
            <div class="tw-font-bold tw-text-700" [class.tw-font-body]="!isReportV2" [class.tw-font-lexend]="isReportV2" i18n="@@skinReport">
              Skin Report
            </div>
          }
          @if (report?.type === appConfig.Shared.Regimen.Class.HAIR) {
            <div class="tw-font-bold tw-text-700" [class.tw-font-body]="!isReportV2" [class.tw-font-lexend]="isReportV2" i18n="@@hairReport">
              Hair Report
            </div>
          }
          <div class="tw-text-300" [class.tw-font-body]="!isReportV2" [class.tw-font-bold]="!isReportV2" [class.tw-font-lexend]="isReportV2">
            {{report?.createdAt | date: 'd MMM yyyy'}}
          </div>
        </div>
        <div class="heading">
          <div class="fontS2 mT5" [class.tw-font-lexend]="isReportV2">
            <div i18n="@@yourReportIsCreatedBy">
              Your check-up report is created by
              <br/>
              <span class="fw-700">{{doctorInfo?.name}}'s</span> team
            </div>
          </div>
          @if (report?.doctor && report?.audioURL) {
            <section class="mT25 mB25 audio">
              <div class="card">
                <c-audio class="c-audio" src="{{report.audioURL}}" imageUrl="{{doctorInfo?.imageUrl}}" eventPrefix="Check-Up" (emitTrackEvent)="trackEvent($event)"></c-audio>
              </div>
              @if (isInternalUser && report.audioNote) {
                <div class="audioNote card">
                  <span class="bold">Audio Note:</span><span class="pL5 fontS1">{{report.audioNote}}</span>
                </div>
              }
            </section>
          }
        </div>
        <div class="content" [class.tw-pb-0]="isReportV2">
          <section>
            <div class="h1" i18n="@@yourTransformation">
              Your Transformation Journey
            </div>
            @for (item of comparisonSliders; track $index; let i = $index) {
              <comparison-slider [index]="i" [sliderLength]="comparisonSliders.length" [report]="item" (back)="back()" [user]="user"></comparison-slider>
            }
          </section>
          @if (isReportV2) {
            @if (report?.treatmentProgress?.length) {
              <div class="tw-px-4 tw-py-5" #progressBar="">
                <div class="tw-font-lexend tw-text-400 tw-font-semibold tw-text-black" i18n="@@improvementObserved">
                  Improvement Observed
                </div>
                <div class="tw-mt-4 tw-flex tw-flex-col tw-gap-5">
                  @for (item of report.treatmentProgress; track item.issue) {
                    <div class="tw-flex tw-flex-col tw-gap-1">
                      <div class="tw-flex tw-items-start tw-justify-between tw-font-body tw-text-300">
                        <span class="tw-text-gray-800">{{treatmentProgressLabel(item)}}</span>
                        <span class="tw-text-right tw-text-gray-400">{{improvementStatusLabel(item.score)}}</span>
                      </div>
                      <div class="tw-h-2 tw-w-full tw-overflow-hidden tw-rounded-6 tw-bg-gray-200">
                        <div class="tw-h-2 tw-rounded-6 tw-transition-all tw-duration-700"
                          [ngClass]="improvementBarColorClass(item.score)"
                          [style.width.%]="improvementBarWidth(item.score)"></div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          } @else {
            @if (report?.observation) {
              <section class="note">
                <div class="h1" i18n="@@observation">Observation</div>
                <div [innerHTML]="report.observation"></div>
              </section>
            }
            @if (report?.treatmentProgress && report.treatmentProgress.length) {
              <section class="progress" #progressBar="">
                <div class="h1" i18n="@@yourTreatmentProgress">
                  Your Transformation Progress
                </div>
                @for (item of report.treatmentProgress; track $index; let i = $index) {
                  <div class="progress-bar">
                    <div class="title">
                      {{item.issue.split('_').join(' ').toLowerCase()}}
                    </div>
                    <progress-bar [value]="item.score" [bgTemplate]="i%2" [stagesLanguageString]="progressBarStages" [animate]="animateProgressBar"></progress-bar>
                  </div>
                }
              </section>
            }
          }
          @if (isReportV2) {
            @if (removedProducts.length || instructionChanged.length || addedProducts.length) {
            <div class="tw-bg-teal-100 tw-px-4 tw-py-6">
              <div class="tw-flex tw-flex-col tw-gap-8">
                @if (removedProducts.length || instructionChanged.length) {
                  <div class="tw-flex tw-flex-col tw-gap-3">
                    <div class="tw-font-lexend tw-text-400 tw-font-semibold tw-text-black" i18n="@@productUpdateInYourTreatment">Product Update in Your Treatment</div>
                    <div class="tw-rounded-3 tw-bg-gray-75 tw-px-2 tw-py-4">
                      <ul class="tw-ml-5 tw-list-disc tw-font-body tw-text-300 tw-font-medium tw-text-gray-800">
                        @for (product of removedProducts; track product.objectId) {
                          <li class="tw-mb-3 last:tw-mb-0"><span i18n="@@removedProduct">Removed product</span> <span class="tw-font-bold"> {{product.title}}</span></li>
                        }
                        @for (product of instructionChanged; track product.objectId) {
                          <li class="tw-mb-3 last:tw-mb-0"><span i18n="@@changeInstructionFor">Change instruction for</span> <span class="tw-font-bold"> {{product.title}}</span></li>
                        }
                      </ul>
                    </div>
                  </div>
                }
                @if (addedProducts.length) {
                  <div class="tw-flex tw-flex-col tw-gap-3">
                    <div class="tw-flex tw-items-center tw-gap-2">
                      <span class="tw-text-400">✅</span>
                      <span class="tw-font-lexend tw-text-400 tw-text-black">
                        <span class="tw-font-semibold" i18n="@@products">Products</span>&nbsp;<span i18n="@@added">Added</span>
                      </span>
                    </div>
                    <div class="tw-flex tw-flex-col tw-gap-2">
                      @for (product of addedProducts; track product.objectId) {
                        <div class="tw-relative">
                          <div class="tw-flex tw-h-[152px] tw-items-center tw-overflow-hidden tw-rounded-3 tw-bg-white">
                            <div class="tw-ml-3 tw-h-[128px] tw-w-[102px] tw-shrink-0 tw-overflow-hidden tw-rounded-2 tw-bg-gray-75">
                              @if (addedProductImage(product)) {
                                <img class="tw-h-full tw-w-full tw-object-cover" [src]="addedProductImage(product)" alt="" />
                              }
                            </div>
                            <div class="tw-mx-4 tw-flex tw-flex-col tw-gap-1">
                              <div class="tw-font-lexend tw-text-400 tw-font-bold tw-text-gray-800">{{product.title}}</div>
                              <div class="tw-font-body tw-text-100 tw-font-medium tw-text-gray-500">{{product.description}}</div>
                            </div>
                          </div>
                          <div class="tw-absolute tw-top-3 tw-right-[-5px] tw-flex tw-flex-col tw-items-end">
                            @if (product.purchased) {
                              <div class="tw-bg-new-tag tw-px-2 tw-py-px tw-font-body tw-text-100 tw-font-bold tw-uppercase tw-text-white" i18n="@@alreadyBought"> Already Bought </div>
                            } @else {
                              <div class="tw-bg-new-tag tw-px-2 tw-py-px tw-font-body tw-text-100 tw-font-bold tw-uppercase tw-text-white" i18n="@@newPlan"> NEW </div>
                            }
                            <div class="tw-h-0 tw-w-0 tw-border-r-[7px] tw-border-t-[7px] tw-border-r-transparent tw-border-t-teal-550"></div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (shouldShowBuyNow()) {
                  <div class="tw-flex tw-h-10 tw-w-full tw-items-center tw-justify-center tw-rounded-2 tw-bg-teal-600 tw-font-lexend tw-text-400 tw-font-semibold tw-text-white" (click)="buyNow('treatmentUpdates')" i18n="@@buyNow">Buy Now</div>
                }
              </div>
            </div>
            } @else if (report?.regimenModifications?.length) {
            <!-- Fallback for reports without stored treatment-update ids (e.g. created before
                 regimenModificationDetails): render the legacy regimenModifications text list. -->
            <div class="tw-bg-teal-100 tw-px-4 tw-py-6">
              <div class="tw-flex tw-flex-col tw-gap-8">
                <div class="tw-flex tw-flex-col tw-gap-3">
                  <div class="tw-font-lexend tw-text-400 tw-font-semibold tw-text-black" i18n="@@productUpdateInYourTreatment">Product Update in Your Treatment</div>
                  <div class="tw-rounded-3 tw-bg-gray-75 tw-px-2 tw-py-4">
                    <ul class="tw-ml-5 tw-list-disc tw-font-body tw-text-300 tw-font-medium tw-text-gray-800">
                      @for (item of report.regimenModifications; track $index) {
                        <li class="tw-mb-3 last:tw-mb-0">{{item}}</li>
                      }
                    </ul>
                  </div>
                </div>
                <div class="tw-flex tw-h-10 tw-w-full tw-items-center tw-justify-center tw-rounded-2 tw-bg-teal-600 tw-font-lexend tw-text-400 tw-font-semibold tw-text-white" (click)="buyNow('regimenModifications')" i18n="@@buyNow">Buy Now</div>
              </div>
            </div>
            }
          } @else {
            @if (report?.regimenModifications) {
              <section class="regimenModification">
                <div class="card">
                  <div class="title bold" i18n="@@yourTreatmentChanged">
                    Your Treatment kit has been Changed
                  </div>
                  @for (item of report.regimenModifications; track $index) {
                    <li>{{item}}</li>
                  }
                  <div
                    class="tw-my-2 tw-w-full tw-bg-teal-600 tw-px-6 tw-h-[48px] tw-flex tw-items-center tw-justify-center tw-rounded-3 tw-text-white tw-text-500 tw-font-semibold"
                    (click)="viewRegimen()">
                    <span class="tw-font-body tw-tracking-normal" i18n="@@viewTreatment">View Treatment kit</span>
                  </div>
                </div>
              </section>
            }
          }
          @if (report?.investigations?.name || report?.investigations?.tests?.length) {
            <investigation-card
              [investigationStatus]="investigationStatusFromReport"
              [doctorImage]="doctorInfo?.imageUrl"
              (uploadClick)="navigateToInstantCheckup()">
            </investigation-card>
          }
          @if (report?.tips) {
            <section class="tips">
              <div class="card">
                <div class="title">
                  <img src="https://cdn.cureskin.com/app/img/heart.svg" /><span i18n="@@importantTip">Important tip from your doctor</span>
                </div>
                <div class="tip">{{report.tips}}</div>
              </div>
            </section>
          }
          @if (report.consentFormAsk) {
            <section class="tips">
              <div class="card" (click)="openConsentForm()">
                <div class="tw-text-center" i18n="@@consentToPrescribeMedicines">
                  Consent to prescribe medicines
                </div>
                <div class="consent-button" i18n="@@open">Open</div>
              </div>
            </section>
          }
          @if (isReportV2) {
            @if (showFeedbackQuestions && !afterSaveFeedback) {
            <div class="tw-bg-yellow-100 tw-px-4 tw-py-8">
              <div class="tw-mx-auto tw-flex tw-max-w-[296px] tw-flex-col tw-gap-8">
                <div class="tw-flex tw-flex-col tw-items-center tw-gap-2.5">
                  <div class="tw-text-center tw-font-lexend tw-text-300 tw-font-semibold tw-text-gray-800" i18n="@@areYouSatisfiedWithTheReport?">
                    Are you satisfied with the Report?
                  </div>
                  <div class="tw-flex tw-items-center tw-gap-2">
                    <div class="tw-flex tw-h-8 tw-w-[97px] tw-items-center tw-justify-center tw-rounded-2 tw-font-lexend tw-text-300 tw-font-semibold tw-shadow-z13"
                      [ngClass]="feedback?.isReportSatisfied === true ? 'tw-bg-teal-600 tw-text-white' : 'tw-bg-gray-75 tw-text-teal-600'"
                      (click)="saveFeedback('isReportSatisfied', true)" i18n="@@yes">Yes</div>
                    <div class="tw-flex tw-h-8 tw-w-[97px] tw-items-center tw-justify-center tw-rounded-2 tw-font-lexend tw-text-300 tw-font-semibold tw-shadow-z13"
                      [ngClass]="feedback?.isReportSatisfied === false ? 'tw-bg-teal-600 tw-text-white' : 'tw-bg-gray-75 tw-text-teal-600'"
                      (click)="saveFeedback('isReportSatisfied', false)" i18n="@@no">No</div>
                  </div>
                </div>
                <div class="tw-flex tw-flex-col tw-items-center tw-gap-2.5">
                  <div class="tw-text-center tw-font-lexend tw-text-300 tw-font-semibold tw-text-gray-800" i18n="@@wereYouAbleToUnderstandTheVoiceNote?">
                    Were you able to understand the Voice note?
                  </div>
                  <div class="tw-flex tw-items-center tw-gap-2">
                    <div class="tw-flex tw-h-8 tw-w-[97px] tw-items-center tw-justify-center tw-rounded-2 tw-font-lexend tw-text-300 tw-font-semibold tw-shadow-z13"
                      [ngClass]="feedback?.isVoiceNoteUnderstandable === true ? 'tw-bg-teal-600 tw-text-white' : 'tw-bg-gray-75 tw-text-teal-600'"
                      (click)="saveFeedback('isVoiceNoteUnderstandable', true)" i18n="@@yes">Yes</div>
                    <div class="tw-flex tw-h-8 tw-w-[97px] tw-items-center tw-justify-center tw-rounded-2 tw-font-lexend tw-text-300 tw-font-semibold tw-shadow-z13"
                      [ngClass]="feedback?.isVoiceNoteUnderstandable === false ? 'tw-bg-teal-600 tw-text-white' : 'tw-bg-gray-75 tw-text-teal-600'"
                      (click)="saveFeedback('isVoiceNoteUnderstandable', false)" i18n="@@no">No</div>
                  </div>
                </div>
                @if (followUpCount > 1) {
                  <div class="tw-flex tw-flex-col tw-items-center tw-gap-2.5">
                    <div class="tw-text-center tw-font-lexend tw-text-300 tw-font-semibold tw-text-gray-800" i18n="@@wereAllYourDoubts/queriesAnswered?">
                      Were all your Doubts/queries answered?
                    </div>
                    <div class="tw-flex tw-items-center tw-gap-2">
                      <div class="tw-flex tw-h-8 tw-w-[97px] tw-items-center tw-justify-center tw-rounded-2 tw-font-lexend tw-text-300 tw-font-semibold tw-shadow-z13"
                        [ngClass]="feedback?.doubtsCleared === true ? 'tw-bg-teal-600 tw-text-white' : 'tw-bg-gray-75 tw-text-teal-600'"
                        (click)="saveFeedback('doubtsCleared', true)" i18n="@@yes">Yes</div>
                      <div class="tw-flex tw-h-8 tw-w-[97px] tw-items-center tw-justify-center tw-rounded-2 tw-font-lexend tw-text-300 tw-font-semibold tw-shadow-z13"
                        [ngClass]="feedback?.doubtsCleared === false ? 'tw-bg-teal-600 tw-text-white' : 'tw-bg-gray-75 tw-text-teal-600'"
                        (click)="saveFeedback('doubtsCleared', false)" i18n="@@no">No</div>
                    </div>
                  </div>
                }
              </div>
            </div>
            }
          } @else {
            @if (showFeedbackQuestions && !afterSaveFeedback) {
              <div class="feedback-question">
                <div class="question" i18n="@@areYouSatisfiedWithTheReport?">
                  Are you satisfied with the Report?
                </div>
                <div class="answer-holder">
                  <div class="btn" i18n="@@yes" (click)="saveFeedback('isReportSatisfied', true)" [ngClass]="{'btn-green': feedback?.isReportSatisfied == true}">Yes</div>
                  <div class="btn mL5" i18n="@@no" (click)="saveFeedback('isReportSatisfied', false)" [ngClass]="{'btn-red': feedback?.isReportSatisfied == false}">No</div>
                </div>
                <div class="question mT20" i18n="@@wereYouAbleToUnderstandTheVoiceNote?">
                  Were you able to understand the Voice note?
                </div>
                <div class="answer-holder">
                  <div class="btn" i18n="@@yes" (click)="saveFeedback('isVoiceNoteUnderstandable', true)" [ngClass]="{'btn-green': feedback?.isVoiceNoteUnderstandable == true}">Yes</div>
                  <div class="btn mL5" i18n="@@no" (click)="saveFeedback('isVoiceNoteUnderstandable', false)" [ngClass]="{'btn-red': feedback?.isVoiceNoteUnderstandable == false}">No</div>
                </div>
                @if (followUpCount > 1) {
                  <div class="question mT20" i18n="@@wereAllYourDoubts/queriesAnswered?">
                    Were all your Doubts/queries answered?
                  </div>
                  <div class="answer-holder">
                    <div class="btn answer" i18n="@@yes" (click)="saveFeedback('doubtsCleared', true)" [ngClass]="{'btn-green': feedback?.doubtsCleared == true}">Yes</div>
                    <div class="btn mL5" i18n="@@no" (click)="saveFeedback('doubtsCleared', false)" [ngClass]="{'btn-red': feedback?.doubtsCleared == false}">No</div>
                  </div>
                }
              </div>
            }
          }
          <div class="feedback-section" #feedbackSection="" [class.tw-p-0]="isReportV2 && !afterSaveFeedback">
            @if (afterSaveFeedback) {
              <div class="feedback card">
                <em class="cs-icon-circle-tick-plain icon"></em>
                <div class="flex-grow mL10" i18n="@@thankYouForYourFeedback">
                  Thank You For Your Feedback
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}

<ng-template #doctorName let-name>
  <span class="fw-700">{{name}}</span>
</ng-template>
